import React, { useState } from "react";

const Todo = () => {
    const [inputData , setInputData] = useState('');
    const [items , setItems] = useState([]);

    const addItem = () => {
        if(!inputData){

        } else {
            setItems([...items, inputData]);
            setInputData('');
        }
    }

    //delete the items

    const deleteItem =(id) => {
        console.log(id);
        const updateditems = items.filter((elem, ind) => {
            return ind != id;
        })
        setItems(updateditems);
    }

    //remove all

    const removeAll = () => {
        setItems([]);
    }

  return (
    <>
    <div>
    <h2>Add your list new</h2>
      <input type="text" className='form-control' placeholder="Add Items ..." value={inputData} onChange={(e) => setInputData(e.target.value) } />
      <button onClick={addItem} className=" btn btn-primary"> Add Item</button>

      {
          items.map((elem, ind) => {
              return (
                  <div className='d-flex align-items-center my-2' key={ind}>
                      <div className="mr-3">{elem}</div>
                      <div className="mx-3"></div>
                      <div><button onClick={() => deleteItem(ind)}  className=" btn btn-danger"> Del</button></div>
                  </div>
              )
          })
      }

      <button onClick={removeAll}  className=" btn btn-danger"> Remove All</button>
</div>
    </>
  )
}

export default Todo;
